import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  DELETE_TASK_BUTTON: `${cleanedFilename(__filename)}-delete-task-button`,
  COMPLETE_TASK_BUTTON: `${cleanedFilename(__filename)}-complete-task-button`,
  REOPEN_TASK_BUTTON: `${cleanedFilename(__filename)}-reopen-task-button`,
};
